import { useSearchParams } from 'hooks/useSearchParams';

const LOAN_ID_PARAM = 'loan_id';

export const useLoanDrawer = () => {
  const { urlParams, addSearchParams, removeSearchParams } =
    useSearchParams<typeof LOAN_ID_PARAM>();

  const rawId = urlParams.get(LOAN_ID_PARAM);
  const loanId = rawId ? Number(rawId) : null;

  const openDrawer = (id: number) => addSearchParams([{ key: LOAN_ID_PARAM, value: String(id) }]);
  const closeDrawer = () => removeSearchParams([LOAN_ID_PARAM]);

  return { loanId, openDrawer, closeDrawer };
};
